// extracted by mini-css-extract-plugin
export default {"cta":"jD-z","disabled":"kD-z"};